export default __webpack_public_path__ + "static/media/EM0480.34I-22666_-15279_0.97e29abd.jpg";